import type { BrandingConfig } from './branding.types.js';

/**
 * Default brand — matches today's EchoSpaces palette so shipping this lib
 * is a visual no-op. Customer deployments override via `provideEsTheme`.
 */
export const DEFAULT_BRANDING: BrandingConfig = {
  name: 'EchoSpaces',
  logoUrl: '/assets/brand/logo.svg',
  logoDarkUrl: '/assets/brand/logo-dark.svg',
  primaryColor: '#4fcdff',
  accentColor: '#ff9b1d',
  fontFamily: '"Exo 2", sans-serif',
};
